import {TrDialog} from "../../Models/tr-dialog";
import {WaitDialog} from "../../Models/wait-dialog";

const WaitDialogView = require('./wait-dialog.html');

interface IScope extends ng.IScope {
  dialog: TrDialog;
  message: string;
}

export const WaitDialogDirective = [
  () => {
    return {
      restrict: 'E',
      scope: {instance: '='},
      templateUrl: WaitDialogView,
      link: (scope: IScope) => {
        scope.dialog = new TrDialog();

        scope.$watch('instance', (value: WaitDialog) => {
          value.open = (message: string, factory: () => Promise<any>) => {
            scope.message = message;
            return new Promise<any>((resolve, reject) => {
              scope.dialog.open();
              factory().then((res) => {
                scope.dialog.close();
                resolve(res);
              }).catch((err) => {
                scope.dialog.close();
                reject(err);
              });
            });
          };
        });
      },
    }
  }
];